import { createStyles } from '@material-ui/core/styles';

export default createStyles({
    parentContainer: {
        width: 'auto',
        height: 'calc(100% - 136px)',
        padding: '2px 15px 2px 2px',
        display: 'flex',
        gap: '10px',
        margin: '15px 0 15px 15px',
    },
    gridContainer: {
        width: '100%',
    },
    summaryContainer: {
        '& .MuiPaper-root': {
            backgroundColor: '#fff',
            margin: 0,
            float: 'unset',
            minWidth: 300
        },
    },
    grid: {
        'height': '100%',
        'width': '100%',
        '& .dx-header-filter:not(.dx-header-filter-empty) ': {
            color: '#5E9ED6',
        },
    },
    SummaryPanelHeight: {
        height: 274,
    }
});
